import { collectDiagnostics, required, validIsoDate } from "./validationUtils.js";

function value(payload: Record<string, unknown>, ...keys: readonly string[]): unknown {
  for (const key of keys) {
    const current = payload[key];
    if (current !== undefined && current !== null && String(current).trim() !== "") return current;
  }
  return undefined;
}

export function validateReportFilter(payload: Record<string, unknown>) {
  const from = value(payload, "dateFromUtc", "fromDate", "dateFrom", "from");
  const to = value(payload, "dateToUtc", "toDate", "dateTo", "to");
  const diagnostics = collectDiagnostics(
    required(value(payload, "reportCode", "code"), "reportCode", "Report"),
    validIsoDate(from, "dateFromUtc", "From date", true),
    validIsoDate(to, "dateToUtc", "To date", true)
  );
  if (from && to) {
    const fromTime = new Date(String(from)).getTime();
    const toTime = new Date(String(to)).getTime();
    if (Number.isFinite(fromTime) && Number.isFinite(toTime)) {
      if (fromTime > toTime) diagnostics.push({ code: "CMTS_INVALID_DATE_RANGE", message: "From date must be earlier than To date.", severity: "error", field: "dateFromUtc" });
      const ninetyThreeDaysMs = 93 * 24 * 60 * 60 * 1000;
      if (toTime - fromTime > ninetyThreeDaysMs) diagnostics.push({ code: "CMTS_REPORT_DATE_RANGE_TOO_LARGE", message: "Report date range must not exceed 93 days for the current tenant policy.", severity: "error", field: "dateToUtc" });
    }
  }
  const exportFormat = value(payload, "exportFormat");
  if (exportFormat && !["CSV", "XLSX", "PDF", "JSON"].includes(String(exportFormat).toUpperCase())) diagnostics.push({ code: "CMTS_INVALID_EXPORT_FORMAT", message: "Export format must be CSV, XLSX, PDF or JSON.", severity: "error", field: "exportFormat" });
  return diagnostics;
}
